import store from '@/store'
import { $odb } from '@axios'
import axios from '@axios'
import { transformRequestOptions } from '@core/utils'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchNorms(ctx, queryParams) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $odb()
                .get('/norms/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        fetchCategories(ctx, queryParams) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $odb()
                .get('/categories/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        fetchBrands(ctx, queryParams) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $odb()
                .get('/brands/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        fetchCountries(ctx, queryParams) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                $odb()
                .get('/countries/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        fetchDatamap(ctx, queryParams) {
            // store.commit('app/LOADING', true)
            return new Promise((resolve, reject) => {
                axios
                .get('/forsta/datamap/', {
                    params: queryParams,
                    paramsSerializer: params => transformRequestOptions(params) 
                })
                .then(response => {
                    // store.commit('app/LOADING', false)
                    resolve(response)
                })
                .catch(error => { 
                    // store.commit('app/LOADING', false)
                    reject(error) 
                })
            })
        },
        fetchDatamapMapping(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                // Adjust the URL based on how you registered the ViewSet in Django urls.py
                axios.get('/odb/data_mapping/sync/', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        saveDatamapMapping(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios.post('/odb/data_mapping/sync/', payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
    }
}